<template>
	<div class="layer-project" data-project-name="genesis-shop">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<!-- Page Contents -->
			<section class="project-visual">
				<div>
					<h1 class="project-tit">
						GENESIS <span class="ib">Shop in Shop</span> <br />Digital Showroom
					</h1>
				</div>
			</section>
			<!-- Details [s] -->
			<section class="project-overview">
				<div class="inner-section">
					<h2 class="project-overview-tit">Overview</h2>
					<p class="project-overview-txt">
						현대자동차의 매장에서 46인치~200인치의 전용 기기 및 iPad Pro를 통해
						제네시스의 차량 소개, 차량 상세 이미지, 가상 주행, 견적 산출 및
						<span
							>시승 예약까지 One-Stop으로 진행할 수 있는 디지털 쇼룸을
							설계했습니다.</span
						>
					</p>
					<div class="project-overview-diagram">
						<ul class="diagram01">
							<li class="item01">Vehicle Introduction</li>
							<li class="item02">Vehicle Image Provided</li>
							<li class="item03">Virtual Driving</li>
							<li class="item04">Estimate</li>
							<li class="item05">Test <br />Driving Reservation</li>
						</ul>
						<ul class="diagram02">
							<li class="item01">GENESIS <span>Shop in Shop</span></li>
						</ul>
					</div>
				</div>
			</section>

			<!-- Details [e] -->
			<section class="section section01">
				<div class="inner-section">
					<strong class="project-subtit">GUI</strong>
					<p class="text">
						실제 스케일과 실사 퀄리티의 VR 자동차를 통한 실감나는 인터렉션을
						경험하게 하고, 이해하기 쉬운 콘텐츠를 제공하여
						<span>구매 결정에 도움이 되는 GUI를 설계하였습니다.</span>
					</p>
					<div class="gui-img-wrap">
						<div class="img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/genesis-shop/gui-img-01@m.png"
							/>
						</div>
						<div class="bottom clfix">
							<div class="img">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/genesis-shop/gui-img-02@m.png"
								/>
							</div>
							<div class="img">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/genesis-shop/gui-img-03@m.png"
								/>
							</div>
							<div class="img">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/genesis-shop/gui-img-04@m.png"
								/>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section class="section section02">
				<strong class="project-subtit">Showroom</strong>
				<div class="img">
					<img
						src=""
						alt=""
						data-src="/static/img/project-detail/genesis-shop/showroom-img-01@m.png"
					/>
				</div>
			</section>
			<section class="section full section03">
				<div class="inner-section">
					<div class="img">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/genesis-shop/showroom-img-02@m.png"
						/>
					</div>
				</div>
			</section>
			<section class="section section04">
				<div class="inner-section">
					<strong class="project-subtit">Printed matters</strong>
					<div class="img">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/genesis-shop/printed-img-01@m.png"
						/>
					</div>
				</div>
			</section>
			<section class="section full section05">
				<div class="inner-section">
					<div class="img">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/genesis-shop/printed-img-02@m.png"
						/>
					</div>
				</div>
			</section>
			<section class="project-client">
				<strong class="a11y-hidden"
					>GENESIS Shop in Shop Digital Showroom</strong
				>
			</section>
			<!-- Page Contents -->
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();
	},
	methods: {},
};
</script>
<!-- css 추가 -->
<style>
@import "../../static/css/projects.css"; /* Common Project Detail Page */
</style>
<style scoped>
/* Common */
.img {
	text-align: center;
}
@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
}
@media screen and (min-width: 1280px) {
}

/* Project Visual, Project CI */
.project-client {
	background: url(/static/img/project-detail/genesis-shop/ci.png) 50% / auto
		69px no-repeat;
}
.project-visual > div {
	padding-top: 30px;
}
@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/genesis-shop/bg-overview@m.jpg);
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/genesis-shop/bg-overview@t.jpg);
	}
	.project-visual > div {
		padding-top: 35px;
	}
	.project-client {
		background-size: auto 107px;
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/genesis-shop/bg-overview@w.jpg);
	}
	.project-visual > div {
		padding-top: 100px;
	}
	.project-client {
		background-size: auto 214px;
	}
}

/* Overview */
.project-overview {
	background-color: #6a7381;
	color: #fff;
}
.project-overview-txt {
	margin-bottom: 30px;
}
.project-overview-diagram li {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 103px;
	height: 103px;
	padding: 10px;
	border-radius: 50%;
	line-height: 1.7rem;
	text-align: center;
	color: #fff;
}
.project-overview-diagram .diagram01 {
	position: relative;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	margin-bottom: 16px;
	padding-bottom: 21px;
}
.project-overview-diagram .diagram01:after {
	content: "";
	position: absolute;
	bottom: 0;
	left: 50%;
	width: 15px;
	height: 15px;
	border-right: 1px solid #fff;
	border-bottom: 1px solid #fff;
	transform: translateX(-50%) rotate(45deg);
}
.project-overview-diagram .diagram01 li {
	margin: -3px -5px;
	border: 1px solid #fff;
}
.project-overview-diagram .diagram02 li {
	background-color: #003a92;
}

@media screen and (max-width: 640px) {
	.project-overview-diagram .diagram01 {
		max-width: 360px;
		margin: 0 auto;
	}
}
@media screen and (max-width: 711px) {
	.project-overview-diagram .diagram02 li {
		margin: 0 auto;
	}
}
@media screen and (min-width: 712px) {
	.project-overview-diagram {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.project-overview-diagram li {
		width: 100px;
		height: 100px;
		padding: 7px;
	}
	.project-overview-diagram .diagram01 {
		margin-bottom: 0;
		margin-right: 28px;
		padding-bottom: 0;
		padding-right: 32px;
	}
	.project-overview-diagram .diagram01 li {
		margin: 0;
	}
	.project-overview-diagram .diagram01 li + li {
		margin-left: -10px;
	}
	.project-overview-diagram .diagram01:after {
		top: 50%;
		bottom: auto;
		left: auto;
		right: 0;
		transform: translateY(-50%) rotate(-45deg);
	}
	.project-overview-diagram .diagram02 li {
		width: 102px;
		height: 102px;
	}
}
@media screen and (min-width: 1280px) {
	.project-overview .inner-section {
		padding-top: 10px;
		padding-bottom: 50px;
	}
	.project-overview-txt {
		margin-bottom: 60px;
	}
	.project-overview-txt span {
		display: block;
	}
	.project-overview-diagram li {
		width: 200px;
		height: 200px;
		padding: 10px;
		font-size: 20px;
		line-height: 1.5;
	}
	.project-overview-diagram .diagram01 .item05 br {
		display: none;
	}
	.project-overview-diagram .diagram02 li {
		width: 205px;
		height: 205px;
	}
}

.section01 {
	background-color: #f1f1f1;
}
.section01 .text {
	margin-bottom: 30px;
}
.gui-img-wrap .bottom,
.gui-img-wrap .img + .img {
	margin-top: 15px;
}
.gui-img-wrap img {
	box-shadow: 0 10px 17px rgba(0, 0, 0, 0.25);
}
@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
	.gui-img-wrap .bottom {
		display: flex;
		margin-top: 30px;
	}
	.gui-img-wrap .bottom .img + .img {
		margin-top: 0;
		margin-left: 22px;
	}
}
@media screen and (min-width: 1280px) {
	.section.section01 {
		max-width: 100%;
		padding-left: 0;
		padding-right: 0;
	}
	.section01 .inner-section {
		max-width: none;
		padding-left: 0;
		padding-right: 0;
	}
	.section01 .project-subtit,
	.section01 .text {
		max-width: 1280px;
		margin: 0 auto;
		padding-left: 20px;
		padding-right: 20px;
	}
	.section01 .text {
		margin-bottom: 50px;
	}
	.section01 .text span {
		display: block;
	}
	.gui-img-wrap {
		position: relative;
		padding-bottom: 656px;
	}
	.gui-img-wrap > .img {
		text-align: center;
	}
	.gui-img-wrap .bottom {
		position: absolute;
		bottom: 100px;
		left: 50%;
		width: 2357px;
		height: 435px;
		transform: translateX(-50%);
	}
	.gui-img-wrap .bottom .img + .img {
		margin-left: 40px;
	}
}
.section02 {
	background-color: #8898a9;
	color: #fff;
}
@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
}
@media screen and (min-width: 1280px) {
	.section02 {
		padding-top: 100px;
	}
	.section02 .project-subtit {
		max-width: 1340px;
		margin: 0 auto;
	}
}
.section.full.section03 {
	padding-bottom: 14px;
}
.section03 {
	background: url(/static/img/project-detail/genesis-shop/showroom-bg@m.png)
		no-repeat;
	background-size: cover;
	text-align: center;
}
@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
	.section03 {
		background-image: url(/static/img/project-detail/genesis-shop/showroom-bg@t.png);
	}
	.section03 .inner-section {
		padding-top: 30px;
		padding-bottom: 20px;
	}
	.section03 .img img {
		width: 54.07303vw;
	}
}
@media screen and (min-width: 1280px) {
	.section03 {
		background-image: url(/static/img/project-detail/genesis-shop/showroom-bg@w.png);
	}
	.section03 .inner-section {
		padding-top: 100px;
		padding-bottom: 60px;
	}
	.section03 .img img {
		width: 770px;
	}
}
.section.section04 {
	padding-bottom: 0px;
}
.section04 {
	background-color: #77787d;
	color: #fff;
}
.section04 .project-subtit {
	margin-bottom: 40px;
}
@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
}
@media screen and (min-width: 1280px) {
	.section04 .inner-section {
		padding-top: 60px;
	}
}
.section.full.section05 {
	padding-top: 35px;
	padding-bottom: 0;
}
.section05 {
	background: url(/static/img/project-detail/genesis-shop/printed-bg@m.png)
		no-repeat;
	background-size: cover;
	text-align: center;
}
@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
	.section05 {
		background-image: url(/static/img/project-detail/genesis-shop/printed-bg@t.png);
	}
}
@media screen and (min-width: 1280px) {
	.section05 {
		background-image: url(/static/img/project-detail/genesis-shop/printed-bg@w.png);
	}
	.section05 .inner-section {
		padding-top: 100px;
	}
}
</style>



// WEBPACK FOOTER //
// src/projects/genesis-shop.vue